<template>
  <div class="home mt-12 text-center">
    <div class="flex flex-col">
      <h2 class="text-3xl mb-4"><span class="text-redapt2">R</span>edapt</h2>
      <div class="text-lg space-y-3">
        <p class="text-red">We are software development firm specializing in web development.</p>
        <!-- <p>We handle both API development as well as design + frontend development.</p> -->
        <!-- <p>Our skills include nodeJS, Golang, VueJS, and serverless.</p> -->
        <!-- <p>These are the same frameworks we use when developing products for our clients.</p> -->
        <!-- <p>Our mission is simple: Deliver re-usable top quality products by code and design standard.</p> -->
        <!-- <button class="btn bg-heading rounded-full ">Email Us</button> -->
      </div>
      <div id="bottomLinks" class="mt-8">
        <a href="mailto:hello@redapt.io">
          <button class="btn bg-white text-redapt2 rounded-full xl:w-1/4 w-1/2 md:w-1/3">Email Us</button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "Home",
  components: {},
};
</script>
